export const itLottomatica = {
  modal: {
    geolocation: {
      content:
        'Lottomatica.it sta per chiederti di accedere alla tua posizione per una migliore fruizione del servizio.',
      title: 'Geolocalizzazione Lottomatica',
    },
  },
  namespaceTest: 'Ciao lottomatica',
};
